export default __webpack_public_path__ + "static/virtual-booth-bg-1-23cf38c311764e006a6f88f626d4ed56.png";